import React from 'react';
import useForm from '../../hooks/formHook.js';
import "../../styles/LandingResetPassword.css";

export default function LandingNewPassword({history}) {
    const { formData, handleChange } = useForm({
        password: '',
        repeatPassword: ''
    });

    return (
        <div className="LandingResetPassword form">
            <h1>New Password <span role="img" aria-label="key" className={navigator.platform.startsWith("Win") && 'emoji-flip'}>🔑</span></h1>
            <form autocomplete="off" onSubmit={(e) => {
                e.preventDefault();
                history.push('/passwordsaved');
                }}>
                <input 
                aria-labelledby="password"
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="New password" />
                <input 
                aria-labelledby="repeat-password"
                type="password"
                name="repeatPassword"
                value={formData.repeatPassword}
                onChange={handleChange}
                placeholder="Confirm new password" />
                <input 
                type="submit"
                value="Save New Password" />
            </form>
        </div>
    )
}